import React, { useEffect, useState } from 'react'

import cx from 'classnames'
import KSC from 'conversations/components/KeyboardShortcutsSidebar/keyboardShortcutsConfig'
import SearchModal from 'conversations/components/SearchModal'
import { getAbilitiesSelector } from 'conversations/modules/user/selectors'
import Hotkeys from 'react-hot-keys'
import { useSelector } from 'react-redux'

const SearchHotkeys: React.FC<{ onTrigger: () => void; children: React.ReactNode }> = ({
  onTrigger,
  children,
}): JSX.Element => {
  return (
    <Hotkeys
      keyName={KSC.basic.search.shortcut}
      onKeyDown={(_, e) => {
        e.preventDefault()
        KSC.basic.search.track()
        onTrigger()
      }}
      filter={() => true}>
      {children}
    </Hotkeys>
  )
}

const SearchTrigger: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [search, setSearch] = useState('')
  const { hasSearch } = useSelector(getAbilitiesSelector)

  useEffect(() => {
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setModalOpen(false)
      }
    }

    window.addEventListener('keyup', handleKeyUp)

    return () => {
      window.removeEventListener('keyup', handleKeyUp)
    }
  }, [setModalOpen])

  if (!hasSearch) {
    return null
  }

  return (
    <>
      <div className={cx(className)} data-ocweb-id="Search">
        <SearchHotkeys onTrigger={() => setModalOpen(true)}>
          <div
            onClick={(e) => {
              setModalOpen(true)
              e.stopPropagation()
            }}>
            {children}
          </div>
        </SearchHotkeys>
      </div>
      <SearchModal
        search={search}
        setSearch={setSearch}
        open={modalOpen}
        onClose={() => {
          setSearch('')
          setModalOpen(false)
        }}
      />
    </>
  )
}

export default SearchTrigger
